// Datos de colores y stock basados en el Google Sheets
export const getProductColors = (productName) => {
  // Función para normalizar nombres (minúsculas, sin tildes, sin espacios, sin 'DS' al final)
  const normalize = str => str
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .replace(/ ds$/i, '')
    .replace(/\s+/g, '')
    .toLowerCase();

  const colorData = {
    // iPhone 13
    "iPhone 13 128 GB": [
      { name: "Blanco", stock: "Bajo Stock", available: true },
      { name: "Negro", stock: "Stock", available: true },
      { name: "Azul", stock: "Sin Stock", available: false },
      { name: "Verde", stock: "Sin Stock", available: false }
    ],
    
    // iPhone 14
    "iPhone 14 128 GB": [
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Negro", stock: "Stock", available: true }
    ],
    
    // iPhone 15
    "iPhone 15 128 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Rosa", stock: "Stock", available: true },
      { name: "Azul", stock: "Bajo Stock", available: true },
      { name: "Verde", stock: "Stock", available: true }
    ],
    
    // iPhone 16
    "iPhone 16 128 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Sin Stock", available: false },
      { name: "Teal (Verde Azulado)", stock: "Stock", available: true },
      { name: "Ultramarine (Azul)", stock: "Stock", available: true },
      { name: "Rosa", stock: "Stock", available: true }
    ],
    "iPhone 16 256 GB": [
      { name: "Negro", stock: "Sin Stock", available: false },
      { name: "Blanco", stock: "Sin Stock", available: false },
      { name: "Teal (Verde Azulado)", stock: "Stock", available: true },
      { name: "Ultramarine (Azul)", stock: "Sin Stock", available: false },
      { name: "Rosa", stock: "Sin Stock", available: false }
    ],
    
    // iPhone 16 Pro
    "iPhone 16 Pro 128 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Natural (Gris)", stock: "Stock", available: true },
      { name: "Desert (Arena)", stock: "Stock", available: true }
    ],
    "iPhone 16 Pro 256 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Natural (Gris)", stock: "Stock", available: true },
      { name: "Desert (Arena)", stock: "Stock", available: true }
    ],
    
    // iPhone 16 Pro Max
    "iPhone 16 Pro Max 256 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Natural (Gris)", stock: "Stock", available: true },
      { name: "Desert (Arena)", stock: "Stock", available: true }
    ],
    "iPhone 16 Pro Max 512 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Natural (Gris)", stock: "Stock", available: true },
      { name: "Desert (Arena)", stock: "Stock", available: true }
    ],
    
    // Samsung
    "Samsung Galaxy S24 128 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Violeta", stock: "Stock", available: true }
    ],
    "Samsung Galaxy S24+ 256 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Violeta", stock: "Stock", available: true }
    ],
    "Samsung Galaxy S24 Ultra 256 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Blanco", stock: "Stock", available: true },
      { name: "Violeta", stock: "Stock", available: true },
      { name: "Titanio", stock: "Stock", available: true }
    ],
    
    // Xiaomi
    "Xiaomi Redmi Note 14 Pro 12/512 GB": [
      { name: "Negro", stock: "Sin Stock", available: false },
      { name: "Blanco", stock: "Sin Stock", available: false },
      { name: "Azul", stock: "Sin Stock", available: false }
    ],
    "Xiaomi Redmi Note 14 Pro 8/256 GB 4G": [
      { name: "Purpura", stock: "Sin Stock", available: false },
      { name: "Celeste", stock: "Sin Stock", available: false },
      { name: "Negro", stock: "Stock", available: true }
    ],
    "Xiaomi Redmi 14C 8/256 GB": [
      { name: "Negro", stock: "Stock", available: true },
      { name: "Azul", stock: "Stock", available: true },
      { name: "Rojo", stock: "Sin Stock", available: false },
      { name: "Lila", stock: "Sin Stock", available: false },
      { name: "Verde", stock: "Sin Stock", available: false }
    ],
    "Xiaomi Redmi 14C 4/128 GB": [
      { name: "Negro", stock: "Bajo Stock", available: true },
      { name: "Verde", stock: "Stock", available: true },
      { name: "Azul", stock: "Sin Stock", available: false },
      { name: "Púrpura", stock: "Sin Stock", available: false }
    ],
    "Xiaomi Redmi A5 4/128 GB": [
      { name: "Negro", stock: "Bajo Stock", available: true },
      { name: "Verde", stock: "Sin Stock", available: false },
      { name: "Azul", stock: "Sin Stock", available: false },
      { name: "Arena", stock: "Sin Stock", available: false },
      { name: "Blanco", stock: "Sin Stock", available: false }
    ]
  };

  // Buscar coincidencia flexible
  const normalizedInput = normalize(productName);
  for (const key in colorData) {
    if (normalize(key) === normalizedInput) {
      return colorData[key];
    }
  }
  return [];
};

// Función para obtener el estado de stock con colores
export const getStockStatusColor = (stock) => {
  switch (stock) {
    case "Stock":
      return "text-green-600 bg-green-100";
    case "Bajo Stock":
      return "text-yellow-600 bg-yellow-100";
    case "Sin Stock":
      return "text-red-600 bg-red-100";
    default:
      return "text-gray-600 bg-gray-100";
  }
}; 